import React from 'react';
import { sortCaret, headerSortingClasses } from '../../../../helpers';
import {
    WidgetDate,
    WidgetTime,
    WidgetLinkTruncatedText,
    ColumnStatus,
} from '../../../../components';
import types from '../../../../constants/movements/types';
import { useTranslation } from 'react-i18next';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';
import { palette } from '../../../../styles/theme';

export default function MovementsColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'auto_id',
        text: t('activity.table.columns.id'),
        sort: true,
        align: 'center',
        headerAlign: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
    },
    {
        dataField: 'id_external_account',
        text: t('activity.table.columns.gpaccount'),
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (cellContent || '-')
    },
    {
        dataField: 'created_at',
        text: t('activity.table.columns.date'),
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <>
                    <WidgetDate date={new Date(cellContent)} />
                    <span> </span>
                    {(cellContent ? <WidgetTime date={new Date(cellContent)} /> : null)}
                </>
            );
        }
    },
    {
        dataField: 'code',
        text: t('activity.table.columns.code'),
        sort: false,
        sortCaret: sortCaret,
        headerClasses: 'clientsColumnsMC_headers--title',
        headerSortingClasses,
    },
    {
        dataField: 'id_creditcard_movement_type',
        text: t('activity.table.columns.type'),
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'center',
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent) => (<ColumnStatus type={''} text={`activity.table.types.${types[cellContent].type}`} />)
    },
    {
        dataField: 'amount',
        text: t('activity.table.columns.amount'),
        align: 'right',
        headerAlign: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        formatter: cellContent => (<WidgetPrice number={cellContent}/>)
    },
    {
        dataField: 'formatted_name',
        text: t('activity.table.columns.client'),
        sort: false,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'left',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/details/${row.id_user}`} text={cellContent || 'S/D'} styles={{ color: palette.secondary[600] }} truncated ='false'/>)
    },
    {
        dataField: 'document',
        text: t('activity.table.columns.document'),
        sort: false,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'left',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (cellContent || '-')
    },
    {
        dataField: 'last_four',
        text: t('activity.table.columns.lastFour'),
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => cellContent || '-'
    },
    {
        dataField: 'merchant_description',
        text: t('activity.table.columns.commerce'),
        sort: false,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'left',
    }
    ];
}
